import { merge } from '../../../helper';

// ----------------------------------------------------------------------------

function removeOptions(element: HTMLSelectElement, find: any, config?: Record<string, any>): void {
    // Default Config
    const defConfig = {
        type: 'value', // 'value' or 'text'
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    find = Array.isArray(find) ? find : [find];

    // Foreach Options
    for (const elOption of element.options) {
        // Foreach Find
        for (const item of find) {
            if (elOption[defConfig.type] === item) {
                elOption.remove();
            }
        }
    }
}

// ----------------------------------------------------------------------------

export default removeOptions;
